import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=62c4c5f3&scoped=true"
import script from "./FormDate.vue?vue&type=script&lang=js"
export * from "./FormDate.vue?vue&type=script&lang=js"
import style0 from "./FormDate.vue?vue&type=style&index=0&id=62c4c5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4c5f3",
  null
  
)

export default component.exports